function initShopByStyleCarousels() {
  document.querySelectorAll('[data-shop-by-style-carousel]').forEach((carousel) => {
    if (carousel.__initialized) return;
    carousel.__initialized = true;

    const track = carousel.querySelector('[data-shop-by-style-track]');
    const prevBtn = document.querySelector('[data-shop-by-style-prev]');
    const nextBtn = document.querySelector('[data-shop-by-style-next]');
    if (!track) return;

    const scrollAmount = () => {
      const card = track.querySelector('.shop-by-style__card');
      if (!card) return 300;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || 24);
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
    window.addEventListener('resize', updateButtons);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopByStyleCarousels);
} else {
  initShopByStyleCarousels();
}

document.addEventListener('shopify:section:load', initShopByStyleCarousels);
